import { z } from 'zod/v4';
export var AuthType;
(function (AuthType) {
    AuthType["Token"] = "TOKEN";
    AuthType["AppToken"] = "APP_TOKEN";
})(AuthType || (AuthType = {}));
export const isAppAuthTokens = (tokens) => tokens.appToken != null;
export var IntegrationId;
(function (IntegrationId) {
    IntegrationId["Economic"] = "cbc4c4af-b811-41ec-b340-179932c5ab2f";
})(IntegrationId || (IntegrationId = {}));
export const TokenIntegrationAuthSchema = z.object({
    token: z.string(),
});
export const AppIntegrationAuthSchema = z.object({
    //appToken: z.string(),
    token: z.string(),
});
export const IntegrationAuthSchema = z.union([
    TokenIntegrationAuthSchema,
    AppIntegrationAuthSchema,
]);
export const AppAuthTokensSchema = z.object({
    appToken: z.string(),
});
export const AuthTokensSchema = z.union([AppAuthTokensSchema, z.object({})]);
export const CreateIntegrationActivationSchema = z.object({
    integrationId: z.uuid(),
    creditorId: z.uuid(),
    tenantId: z.uuid(),
    options: z.object({}).passthrough(),
    authentication: IntegrationAuthSchema,
    tokens: AuthTokensSchema,
});
export const CreateIntegrationActivationEndpointSchema = z.object({
    creditorId: z.uuid(),
    authentication: IntegrationAuthSchema,
    options: z.object({}).passthrough(),
});
//# sourceMappingURL=index.js.map